import { CookiesController } from '../CookiesController.js';

class PageLoaderController {
    constructor(pageLoaderType) {
        this.PageLoaderWrapper = document.getElementById("PageLoaderWrapper");
        this.PageLoaderType = pageLoaderType;
        this.initPageLoader();
    }

    initPageLoader(){
        switch (this.PageLoaderType){
        case 'always':
            this.showPageLoader();
            break;
        case 'session':
            this.showPageLoaderPerSession();
            break;
        default:
            break;
        }            
    }

    showPageLoaderPerSession(){
        if(CookiesController.readSOSCookie('page_loader', 'shown'))
            return;
        else{
            this.showPageLoader();
            CookiesController.createSOSSessionCookie('page_loader', 'shown', true);
        }
    }

    showPageLoader(){
        let wrapper = this.PageLoaderWrapper;
        setTimeout(function hide() {
            if (wrapper.classList.contains("hide-page-loader")) {
                wrapper.classList.remove("hide-page-loader");
            }
            else {
                wrapper.classList.add("hide-page-loader");
            }
        }, 1500);
        setTimeout(function hide() {
            var wrapper = document.getElementById("PageLoaderWrapper");
            wrapper.classList.add("hidden");
        }, 3000);
    }
    
    static init(pageLoaderType) {
        new PageLoaderController(pageLoaderType);
    }
}

window.PageLoaderController = PageLoaderController;
export default PageLoaderController;
